export class CatalogDesk {

    private centerName: string;
    private turnDeskInternalId: string;
    private turnDeskName: string;

    constructor(centerName?: string, turnDeskInternalId?: string, turnDeskName?: string) {
        this.centerName = centerName;
        this.turnDeskInternalId = turnDeskInternalId;
        this.turnDeskName = turnDeskName;
    }

    public get CenterName(): string {
        return this.centerName;
    }

    public get TurnDeskInternalId(): string {
        return this.turnDeskInternalId;
    }

    public get TurnDeskName(): string {
        return this.turnDeskName;
    }

    public set CenterName(centerName: string) {
        this.centerName = centerName;
    }

    public set TurnDeskInternalId(turnDeskInternalId: string) {
        this.turnDeskInternalId = turnDeskInternalId;
    }

    public set TurnDeskName(turnDeskName: string) {
        this.turnDeskName = turnDeskName;
    }
}
